import useSWR from "swr";
import currencyExchangeService from "../services/currencyExchangeService";
import { baseApiService } from "shared/api";

export function useExchange({ amount, currency, costLineId }, options = {}) {
  return useSWR(
    amount && currency
      ? [baseApiService.ENDPOINTS.currency, amount, currency, costLineId]
      : null,
    ([url, amount, currency]) =>
      currencyExchangeService.getExchange([url, amount, currency]),
    {
      revalidateOnFocus: false,
      onError: () => null,
      ...options,
    }
  );
}
